import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';

@Component({
    selector: 'pwa-points-banner',
    templateUrl: './pwa-points-banner.html',
    styleUrls: ['./pwa-points-banner.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule]
})
export class PwaPointsBannerComponent {
    @Input({ required: true })
    points!: number;

    @Input()
    type: 'coins' | 'rosettes' = 'coins';

    @Input()
    text?: string;
}
